// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__KuT-s","wrap":"Layout_wrap__3Y4cM","sidebarOpen":"Layout_sidebarOpen__2IVP8","content":"Layout_content__3nMgS"};